// User authentication logic

import { getAPI, token } from "@/api/params.js";
import jwt_decode from "jwt-decode";
import { Message } from "element-ui";
import store from "@/store";

/**
 * Get user information from Mangomolo
 */
export const getUserData = async () => {
  const formData = new FormData();
  formData.append("token", token);

  const resp = await fetch(
    `${getAPI()}/authorize?token=${token}&demo=demoUser`
  );

  if (!resp.ok) {
    return null;
  }

  const obj = await resp.json();
  return obj.data;
};

export const getTokenAdmin = async (login, password) => {
  const url = `${getAPI()}/admin_auth/signin`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({
      username: login,
      password: password
    })
  });

  // .then(response => response.json());

  if (resp.ok) {
    const resp1 = await resp.json();
    store.commit("admin/checkToken", resp1.refreshToken);

    localStorage.setItem("accessToken", resp1.accessToken);
    localStorage.setItem("refreshToken", resp1.refreshToken);
    return resp1;
  } else {
    if (resp.json) {
      throw new Error((await resp.json()).error);
    }
    throw Error(resp.statusText);
    // this.$message.error("Oops, this is a error message.");
  }
  // return resp;
};

export const getTokenAdminRefresh = async () => {
  const refreshToken = localStorage.getItem(`refreshToken`);
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${refreshToken}`);

  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };

  return fetch(`${getAPI()}/admin_auth/refresh`, requestOptions)
    .then(response => {
      if (!response.ok) {
        throw Error("Unauthorized");
      }
      return response.json();
    })
    .then(result => {
      localStorage.setItem("accessToken", result.accessToken);
      localStorage.setItem("refreshToken", result.refreshToken);
    });
};

export const getWorkerScaling = async () => {
  const accessToken = localStorage.getItem(`accessToken`);
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${accessToken}`);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };

  return fetch(`${getAPI()}/worker/scaling/`, requestOptions).then(response => {
    if (!response.ok) {
      throw Error("Unauthorized");
    }
    return response.json();
  });
};

export const checkToken = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const decoded = jwt_decode(token);
    if (Date.now() >= decoded.exp * 1000) throw Error;
    return token;
  } catch {
    if (localStorage.getItem(`refreshToken`)) {
      try {
        await getTokenAdminRefresh();
      } catch {
        logout();
      }
    }
    return localStorage.getItem("accessToken");
  }
};

export const logout = async () => {
  const refrToken = localStorage.getItem(`refreshToken`);
  
  store.commit("admin/checkToken",'');

  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  const response = await fetch(`${getAPI()}/admin_auth/logout`, {
    headers: {
      Authorization: `Bearer ${refrToken}`
    }
  });

  if (response.ok) {
    // если HTTP-статус в диапазоне 200-299
    // получаем тело ответа (см. про этот метод ниже)
    const json = await response.json();
  } else {
    // alert("Ошибка HTTP: " + response.status);
  }
};
